import React from 'react';

// Red when a monthly send failed for good, amber while it is retrying or the bills changed after sending.
export default function GstDeliveryBanner({ dispatches, onOpen }) {
  const issues = [];
  for (const d of dispatches || []) {
    if (d.status === 'failed') issues.push({ red: true, text: `The ${d.month} GST report could not be sent to the CA: ${d.lastError || 'unknown error'}.` });
    else if (d.status === 'pending' && d.lastError) issues.push({ red: false, text: `The ${d.month} GST report is still being retried (${d.lastError}).` });
    else if (d.changedSinceSent) issues.push({ red: false, text: `Bills for ${d.month} changed after the report was sent to the CA.` });
  }
  if (!issues.length) return null;
  const red = issues.some((i) => i.red);
  return (
    <div className="card" style={{ padding: '10px 14px', marginBottom: 12, borderLeft: `4px solid ${red ? '#dc2626' : '#d97706'}` }}>
      {issues.map((i, k) => <div key={k}>{i.text}</div>)}
      <button className="btn btn-secondary" style={{ marginTop: 6 }} onClick={onOpen}>Open CA delivery</button>
    </div>
  );
}
